import * as React from 'react';
// mui
import {
  Box,
  Skeleton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  IconButton
} from '@mui/material';
// icons
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

interface TaskListSkeletonProps {
  depth?: number; // how many levels deep the skeleton should simulate
  padding?: number;
  tasksPerLevel?: number;
}

export default function TaskListSkeleton({
  depth = 2,
  padding = 2,
  tasksPerLevel = 2
}: TaskListSkeletonProps) {
  const renderSkeletonTasks = (level: number): React.ReactNode => {
    if (level > depth) return null;

    return Array.from({ length: tasksPerLevel }).map((_, index) => (
      <Box key={`${level}-${index}`}>
        <ListItem sx={{ pl: padding * level }}>
          <ListItemIcon>
            <IconButton disabled>
              <KeyboardArrowRightIcon />
            </IconButton>
          </ListItemIcon>
          <ListItemText
            primary={<Skeleton width="60%" />}
            secondary={
              <Skeleton width="80%" height={20} />
            }
          />
          <Skeleton variant="circular" width={24} height={24} sx={{ marginRight: 1 }} />
          <Skeleton variant="circular" width={24} height={24} />
        </ListItem>

        {/* Optionally simulate subtasks */}
        <Collapse in={true} timeout="auto" unmountOnExit>
          <List disablePadding>
            {renderSkeletonTasks(level + 1)}
          </List>
        </Collapse>
      </Box>
    ));
  };

  return (
    <List disablePadding>
      {renderSkeletonTasks(1)}
    </List>
  );
}
